/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedWebhooksRouteImport } from './routes/_authed.webhooks'
import { Route as AuthedUsersRouteImport } from './routes/_authed.users'
import { Route as AuthedTranslationsLegacyRouteImport } from './routes/_authed.translations-legacy'
import { Route as AuthedTranslationsRouteImport } from './routes/_authed.translations'
import { Route as AuthedSubscriptionsRouteImport } from './routes/_authed.subscriptions'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedSchoolsRouteImport } from './routes/_authed.schools'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedPlansRouteImport } from './routes/_authed.plans'
import { Route as AuthedPaymentsRouteImport } from './routes/_authed.payments'
import { Route as AuthedPagesRouteImport } from './routes/_authed.pages'
import { Route as AuthedMediaRouteImport } from './routes/_authed.media'
import { Route as AuthedLanguagesRouteImport } from './routes/_authed.languages'
import { Route as AuthedFlagsRouteImport } from './routes/_authed.flags'
import { Route as AuthedFamiliesRouteImport } from './routes/_authed.families'
import { Route as AuthedEmailRouteImport } from './routes/_authed.email'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedCouponsRouteImport } from './routes/_authed.coupons'
import { Route as AuthedContentRouteImport } from './routes/_authed.content'
import { Route as AuthedBlogCategoriesRouteImport } from './routes/_authed.blog-categories'
import { Route as AuthedBlogRouteImport } from './routes/_authed.blog'
import { Route as AuthedAuditRouteImport } from './routes/_authed.audit'
import { Route as AuthedAnnouncementsRouteImport } from './routes/_authed.announcements'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed.users.index'
import { Route as AuthedSchoolsIndexRouteImport } from './routes/_authed.schools.index'
import { Route as AuthedPagesIndexRouteImport } from './routes/_authed.pages.index'
import { Route as AuthedFamiliesIndexRouteImport } from './routes/_authed.families.index'
import { Route as AuthedContentIndexRouteImport } from './routes/_authed.content.index'
import { Route as AuthedBlogIndexRouteImport } from './routes/_authed.blog.index'
import { Route as AuthedBlogCategoriesIndexRouteImport } from './routes/_authed.blog-categories.index'
import { Route as AuthedUsersIdRouteImport } from './routes/_authed.users.$id'
import { Route as AuthedSchoolsIdRouteImport } from './routes/_authed.schools.$id'
import { Route as AuthedPagesIdRouteImport } from './routes/_authed.pages.$id'
import { Route as AuthedFamiliesIdRouteImport } from './routes/_authed.families.$id'
import { Route as AuthedBlogNewRouteImport } from './routes/_authed.blog.new'
import { Route as AuthedBlogIdRouteImport } from './routes/_authed.blog.$id'
import { Route as AuthedBlogCategoriesNewRouteImport } from './routes/_authed.blog-categories.new'
import { Route as AuthedBlogCategoriesIdRouteImport } from './routes/_authed.blog-categories.$id'
import { Route as AuthedContentLessonsIdRouteImport } from './routes/_authed.content.lessons.$id'
import { Route as AuthedPagesIdBlocksBlockIdRouteImport } from './routes/_authed.pages.$id_.blocks.$blockId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedWebhooksRoute = AuthedWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTranslationsLegacyRoute =
  AuthedTranslationsLegacyRouteImport.update({
    id: '/translations-legacy',
    path: '/translations-legacy',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTranslationsRoute = AuthedTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSubscriptionsRoute = AuthedSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSchoolsRoute = AuthedSchoolsRouteImport.update({
  id: '/schools',
  path: '/schools',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPlansRoute = AuthedPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsRoute = AuthedPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPagesRoute = AuthedPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMediaRoute = AuthedMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLanguagesRoute = AuthedLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFlagsRoute = AuthedFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFamiliesRoute = AuthedFamiliesRouteImport.update({
  id: '/families',
  path: '/families',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEmailRoute = AuthedEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCouponsRoute = AuthedCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContentRoute = AuthedContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBlogCategoriesRoute = AuthedBlogCategoriesRouteImport.update({
  id: '/blog-categories',
  path: '/blog-categories',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBlogRoute = AuthedBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnnouncementsRoute = AuthedAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedUsersRoute,
} as any)
const AuthedSchoolsIndexRoute = AuthedSchoolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSchoolsRoute,
} as any)
const AuthedPagesIndexRoute = AuthedPagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedPagesRoute,
} as any)
const AuthedFamiliesIndexRoute = AuthedFamiliesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFamiliesRoute,
} as any)
const AuthedContentIndexRoute = AuthedContentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedContentRoute,
} as any)
const AuthedBlogIndexRoute = AuthedBlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedBlogRoute,
} as any)
const AuthedBlogCategoriesIndexRoute =
  AuthedBlogCategoriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedBlogCategoriesRoute,
  } as any)
const AuthedUsersIdRoute = AuthedUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedUsersRoute,
} as any)
const AuthedSchoolsIdRoute = AuthedSchoolsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedSchoolsRoute,
} as any)
const AuthedPagesIdRoute = AuthedPagesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedPagesRoute,
} as any)
const AuthedFamiliesIdRoute = AuthedFamiliesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedFamiliesRoute,
} as any)
const AuthedBlogNewRoute = AuthedBlogNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedBlogRoute,
} as any)
const AuthedBlogIdRoute = AuthedBlogIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedBlogRoute,
} as any)
const AuthedBlogCategoriesNewRoute = AuthedBlogCategoriesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedBlogCategoriesRoute,
} as any)
const AuthedBlogCategoriesIdRoute = AuthedBlogCategoriesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedBlogCategoriesRoute,
} as any)
const AuthedContentLessonsIdRoute = AuthedContentLessonsIdRouteImport.update({
  id: '/lessons/$id',
  path: '/lessons/$id',
  getParentRoute: () => AuthedContentRoute,
} as any)
const AuthedPagesIdBlocksBlockIdRoute =
  AuthedPagesIdBlocksBlockIdRouteImport.update({
    id: '/$id_/blocks/$blockId',
    path: '/$id/blocks/$blockId',
    getParentRoute: () => AuthedPagesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/audit': typeof AuthedAuditRoute
  '/blog': typeof AuthedBlogRouteWithChildren
  '/blog-categories': typeof AuthedBlogCategoriesRouteWithChildren
  '/content': typeof AuthedContentRouteWithChildren
  '/coupons': typeof AuthedCouponsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/email': typeof AuthedEmailRoute
  '/families': typeof AuthedFamiliesRouteWithChildren
  '/flags': typeof AuthedFlagsRoute
  '/languages': typeof AuthedLanguagesRoute
  '/media': typeof AuthedMediaRoute
  '/pages': typeof AuthedPagesRouteWithChildren
  '/payments': typeof AuthedPaymentsRoute
  '/plans': typeof AuthedPlansRoute
  '/reports': typeof AuthedReportsRoute
  '/schools': typeof AuthedSchoolsRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/subscriptions': typeof AuthedSubscriptionsRoute
  '/translations': typeof AuthedTranslationsRoute
  '/translations-legacy': typeof AuthedTranslationsLegacyRoute
  '/users': typeof AuthedUsersRouteWithChildren
  '/webhooks': typeof AuthedWebhooksRoute
  '/blog-categories/$id': typeof AuthedBlogCategoriesIdRoute
  '/blog-categories/new': typeof AuthedBlogCategoriesNewRoute
  '/blog/$id': typeof AuthedBlogIdRoute
  '/blog/new': typeof AuthedBlogNewRoute
  '/families/$id': typeof AuthedFamiliesIdRoute
  '/pages/$id': typeof AuthedPagesIdRoute
  '/schools/$id': typeof AuthedSchoolsIdRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/blog-categories/': typeof AuthedBlogCategoriesIndexRoute
  '/blog/': typeof AuthedBlogIndexRoute
  '/content/': typeof AuthedContentIndexRoute
  '/families/': typeof AuthedFamiliesIndexRoute
  '/pages/': typeof AuthedPagesIndexRoute
  '/schools/': typeof AuthedSchoolsIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/content/lessons/$id': typeof AuthedContentLessonsIdRoute
  '/pages/$id/blocks/$blockId': typeof AuthedPagesIdBlocksBlockIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/announcements': typeof AuthedAnnouncementsRoute
  '/audit': typeof AuthedAuditRoute
  '/coupons': typeof AuthedCouponsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/email': typeof AuthedEmailRoute
  '/flags': typeof AuthedFlagsRoute
  '/languages': typeof AuthedLanguagesRoute
  '/media': typeof AuthedMediaRoute
  '/payments': typeof AuthedPaymentsRoute
  '/plans': typeof AuthedPlansRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRoute
  '/subscriptions': typeof AuthedSubscriptionsRoute
  '/translations': typeof AuthedTranslationsRoute
  '/translations-legacy': typeof AuthedTranslationsLegacyRoute
  '/webhooks': typeof AuthedWebhooksRoute
  '/blog-categories/$id': typeof AuthedBlogCategoriesIdRoute
  '/blog-categories/new': typeof AuthedBlogCategoriesNewRoute
  '/blog/$id': typeof AuthedBlogIdRoute
  '/blog/new': typeof AuthedBlogNewRoute
  '/families/$id': typeof AuthedFamiliesIdRoute
  '/pages/$id': typeof AuthedPagesIdRoute
  '/schools/$id': typeof AuthedSchoolsIdRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/blog-categories': typeof AuthedBlogCategoriesIndexRoute
  '/blog': typeof AuthedBlogIndexRoute
  '/content': typeof AuthedContentIndexRoute
  '/families': typeof AuthedFamiliesIndexRoute
  '/pages': typeof AuthedPagesIndexRoute
  '/schools': typeof AuthedSchoolsIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/content/lessons/$id': typeof AuthedContentLessonsIdRoute
  '/pages/$id/blocks/$blockId': typeof AuthedPagesIdBlocksBlockIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/announcements': typeof AuthedAnnouncementsRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/blog': typeof AuthedBlogRouteWithChildren
  '/_authed/blog-categories': typeof AuthedBlogCategoriesRouteWithChildren
  '/_authed/content': typeof AuthedContentRouteWithChildren
  '/_authed/coupons': typeof AuthedCouponsRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/email': typeof AuthedEmailRoute
  '/_authed/families': typeof AuthedFamiliesRouteWithChildren
  '/_authed/flags': typeof AuthedFlagsRoute
  '/_authed/languages': typeof AuthedLanguagesRoute
  '/_authed/media': typeof AuthedMediaRoute
  '/_authed/pages': typeof AuthedPagesRouteWithChildren
  '/_authed/payments': typeof AuthedPaymentsRoute
  '/_authed/plans': typeof AuthedPlansRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/schools': typeof AuthedSchoolsRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/subscriptions': typeof AuthedSubscriptionsRoute
  '/_authed/translations': typeof AuthedTranslationsRoute
  '/_authed/translations-legacy': typeof AuthedTranslationsLegacyRoute
  '/_authed/users': typeof AuthedUsersRouteWithChildren
  '/_authed/webhooks': typeof AuthedWebhooksRoute
  '/_authed/blog-categories/$id': typeof AuthedBlogCategoriesIdRoute
  '/_authed/blog-categories/new': typeof AuthedBlogCategoriesNewRoute
  '/_authed/blog/$id': typeof AuthedBlogIdRoute
  '/_authed/blog/new': typeof AuthedBlogNewRoute
  '/_authed/families/$id': typeof AuthedFamiliesIdRoute
  '/_authed/pages/$id': typeof AuthedPagesIdRoute
  '/_authed/schools/$id': typeof AuthedSchoolsIdRoute
  '/_authed/users/$id': typeof AuthedUsersIdRoute
  '/_authed/blog-categories/': typeof AuthedBlogCategoriesIndexRoute
  '/_authed/blog/': typeof AuthedBlogIndexRoute
  '/_authed/content/': typeof AuthedContentIndexRoute
  '/_authed/families/': typeof AuthedFamiliesIndexRoute
  '/_authed/pages/': typeof AuthedPagesIndexRoute
  '/_authed/schools/': typeof AuthedSchoolsIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/content/lessons/$id': typeof AuthedContentLessonsIdRoute
  '/_authed/pages/$id_/blocks/$blockId': typeof AuthedPagesIdBlocksBlockIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/announcements'
    | '/audit'
    | '/blog'
    | '/blog-categories'
    | '/content'
    | '/coupons'
    | '/dashboard'
    | '/email'
    | '/families'
    | '/flags'
    | '/languages'
    | '/media'
    | '/pages'
    | '/payments'
    | '/plans'
    | '/reports'
    | '/schools'
    | '/settings'
    | '/subscriptions'
    | '/translations'
    | '/translations-legacy'
    | '/users'
    | '/webhooks'
    | '/blog-categories/$id'
    | '/blog-categories/new'
    | '/blog/$id'
    | '/blog/new'
    | '/families/$id'
    | '/pages/$id'
    | '/schools/$id'
    | '/users/$id'
    | '/blog-categories/'
    | '/blog/'
    | '/content/'
    | '/families/'
    | '/pages/'
    | '/schools/'
    | '/users/'
    | '/content/lessons/$id'
    | '/pages/$id/blocks/$blockId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/announcements'
    | '/audit'
    | '/coupons'
    | '/dashboard'
    | '/email'
    | '/flags'
    | '/languages'
    | '/media'
    | '/payments'
    | '/plans'
    | '/reports'
    | '/settings'
    | '/subscriptions'
    | '/translations'
    | '/translations-legacy'
    | '/webhooks'
    | '/blog-categories/$id'
    | '/blog-categories/new'
    | '/blog/$id'
    | '/blog/new'
    | '/families/$id'
    | '/pages/$id'
    | '/schools/$id'
    | '/users/$id'
    | '/blog-categories'
    | '/blog'
    | '/content'
    | '/families'
    | '/pages'
    | '/schools'
    | '/users'
    | '/content/lessons/$id'
    | '/pages/$id/blocks/$blockId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/announcements'
    | '/_authed/audit'
    | '/_authed/blog'
    | '/_authed/blog-categories'
    | '/_authed/content'
    | '/_authed/coupons'
    | '/_authed/dashboard'
    | '/_authed/email'
    | '/_authed/families'
    | '/_authed/flags'
    | '/_authed/languages'
    | '/_authed/media'
    | '/_authed/pages'
    | '/_authed/payments'
    | '/_authed/plans'
    | '/_authed/reports'
    | '/_authed/schools'
    | '/_authed/settings'
    | '/_authed/subscriptions'
    | '/_authed/translations'
    | '/_authed/translations-legacy'
    | '/_authed/users'
    | '/_authed/webhooks'
    | '/_authed/blog-categories/$id'
    | '/_authed/blog-categories/new'
    | '/_authed/blog/$id'
    | '/_authed/blog/new'
    | '/_authed/families/$id'
    | '/_authed/pages/$id'
    | '/_authed/schools/$id'
    | '/_authed/users/$id'
    | '/_authed/blog-categories/'
    | '/_authed/blog/'
    | '/_authed/content/'
    | '/_authed/families/'
    | '/_authed/pages/'
    | '/_authed/schools/'
    | '/_authed/users/'
    | '/_authed/content/lessons/$id'
    | '/_authed/pages/$id_/blocks/$blockId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/webhooks': {
      id: '/_authed/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AuthedWebhooksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/translations-legacy': {
      id: '/_authed/translations-legacy'
      path: '/translations-legacy'
      fullPath: '/translations-legacy'
      preLoaderRoute: typeof AuthedTranslationsLegacyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/translations': {
      id: '/_authed/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof AuthedTranslationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/subscriptions': {
      id: '/_authed/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthedSubscriptionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schools': {
      id: '/_authed/schools'
      path: '/schools'
      fullPath: '/schools'
      preLoaderRoute: typeof AuthedSchoolsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/plans': {
      id: '/_authed/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthedPlansRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments': {
      id: '/_authed/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthedPaymentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pages': {
      id: '/_authed/pages'
      path: '/pages'
      fullPath: '/pages'
      preLoaderRoute: typeof AuthedPagesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/media': {
      id: '/_authed/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AuthedMediaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/languages': {
      id: '/_authed/languages'
      path: '/languages'
      fullPath: '/languages'
      preLoaderRoute: typeof AuthedLanguagesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/flags': {
      id: '/_authed/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof AuthedFlagsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/families': {
      id: '/_authed/families'
      path: '/families'
      fullPath: '/families'
      preLoaderRoute: typeof AuthedFamiliesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/email': {
      id: '/_authed/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof AuthedEmailRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/coupons': {
      id: '/_authed/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof AuthedCouponsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/content': {
      id: '/_authed/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof AuthedContentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/blog-categories': {
      id: '/_authed/blog-categories'
      path: '/blog-categories'
      fullPath: '/blog-categories'
      preLoaderRoute: typeof AuthedBlogCategoriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/blog': {
      id: '/_authed/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof AuthedBlogRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/announcements': {
      id: '/_authed/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthedAnnouncementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedUsersRoute
    }
    '/_authed/schools/': {
      id: '/_authed/schools/'
      path: '/'
      fullPath: '/schools/'
      preLoaderRoute: typeof AuthedSchoolsIndexRouteImport
      parentRoute: typeof AuthedSchoolsRoute
    }
    '/_authed/pages/': {
      id: '/_authed/pages/'
      path: '/'
      fullPath: '/pages/'
      preLoaderRoute: typeof AuthedPagesIndexRouteImport
      parentRoute: typeof AuthedPagesRoute
    }
    '/_authed/families/': {
      id: '/_authed/families/'
      path: '/'
      fullPath: '/families/'
      preLoaderRoute: typeof AuthedFamiliesIndexRouteImport
      parentRoute: typeof AuthedFamiliesRoute
    }
    '/_authed/content/': {
      id: '/_authed/content/'
      path: '/'
      fullPath: '/content/'
      preLoaderRoute: typeof AuthedContentIndexRouteImport
      parentRoute: typeof AuthedContentRoute
    }
    '/_authed/blog/': {
      id: '/_authed/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof AuthedBlogIndexRouteImport
      parentRoute: typeof AuthedBlogRoute
    }
    '/_authed/blog-categories/': {
      id: '/_authed/blog-categories/'
      path: '/'
      fullPath: '/blog-categories/'
      preLoaderRoute: typeof AuthedBlogCategoriesIndexRouteImport
      parentRoute: typeof AuthedBlogCategoriesRoute
    }
    '/_authed/users/$id': {
      id: '/_authed/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthedUsersIdRouteImport
      parentRoute: typeof AuthedUsersRoute
    }
    '/_authed/schools/$id': {
      id: '/_authed/schools/$id'
      path: '/$id'
      fullPath: '/schools/$id'
      preLoaderRoute: typeof AuthedSchoolsIdRouteImport
      parentRoute: typeof AuthedSchoolsRoute
    }
    '/_authed/pages/$id': {
      id: '/_authed/pages/$id'
      path: '/$id'
      fullPath: '/pages/$id'
      preLoaderRoute: typeof AuthedPagesIdRouteImport
      parentRoute: typeof AuthedPagesRoute
    }
    '/_authed/families/$id': {
      id: '/_authed/families/$id'
      path: '/$id'
      fullPath: '/families/$id'
      preLoaderRoute: typeof AuthedFamiliesIdRouteImport
      parentRoute: typeof AuthedFamiliesRoute
    }
    '/_authed/blog/new': {
      id: '/_authed/blog/new'
      path: '/new'
      fullPath: '/blog/new'
      preLoaderRoute: typeof AuthedBlogNewRouteImport
      parentRoute: typeof AuthedBlogRoute
    }
    '/_authed/blog/$id': {
      id: '/_authed/blog/$id'
      path: '/$id'
      fullPath: '/blog/$id'
      preLoaderRoute: typeof AuthedBlogIdRouteImport
      parentRoute: typeof AuthedBlogRoute
    }
    '/_authed/blog-categories/new': {
      id: '/_authed/blog-categories/new'
      path: '/new'
      fullPath: '/blog-categories/new'
      preLoaderRoute: typeof AuthedBlogCategoriesNewRouteImport
      parentRoute: typeof AuthedBlogCategoriesRoute
    }
    '/_authed/blog-categories/$id': {
      id: '/_authed/blog-categories/$id'
      path: '/$id'
      fullPath: '/blog-categories/$id'
      preLoaderRoute: typeof AuthedBlogCategoriesIdRouteImport
      parentRoute: typeof AuthedBlogCategoriesRoute
    }
    '/_authed/content/lessons/$id': {
      id: '/_authed/content/lessons/$id'
      path: '/lessons/$id'
      fullPath: '/content/lessons/$id'
      preLoaderRoute: typeof AuthedContentLessonsIdRouteImport
      parentRoute: typeof AuthedContentRoute
    }
    '/_authed/pages/$id_/blocks/$blockId': {
      id: '/_authed/pages/$id_/blocks/$blockId'
      path: '/$id/blocks/$blockId'
      fullPath: '/pages/$id/blocks/$blockId'
      preLoaderRoute: typeof AuthedPagesIdBlocksBlockIdRouteImport
      parentRoute: typeof AuthedPagesRoute
    }
  }
}

interface AuthedBlogRouteChildren {
  AuthedBlogIdRoute: typeof AuthedBlogIdRoute
  AuthedBlogNewRoute: typeof AuthedBlogNewRoute
  AuthedBlogIndexRoute: typeof AuthedBlogIndexRoute
}

const AuthedBlogRouteChildren: AuthedBlogRouteChildren = {
  AuthedBlogIdRoute: AuthedBlogIdRoute,
  AuthedBlogNewRoute: AuthedBlogNewRoute,
  AuthedBlogIndexRoute: AuthedBlogIndexRoute,
}

const AuthedBlogRouteWithChildren = AuthedBlogRoute._addFileChildren(
  AuthedBlogRouteChildren,
)

interface AuthedBlogCategoriesRouteChildren {
  AuthedBlogCategoriesIdRoute: typeof AuthedBlogCategoriesIdRoute
  AuthedBlogCategoriesNewRoute: typeof AuthedBlogCategoriesNewRoute
  AuthedBlogCategoriesIndexRoute: typeof AuthedBlogCategoriesIndexRoute
}

const AuthedBlogCategoriesRouteChildren: AuthedBlogCategoriesRouteChildren = {
  AuthedBlogCategoriesIdRoute: AuthedBlogCategoriesIdRoute,
  AuthedBlogCategoriesNewRoute: AuthedBlogCategoriesNewRoute,
  AuthedBlogCategoriesIndexRoute: AuthedBlogCategoriesIndexRoute,
}

const AuthedBlogCategoriesRouteWithChildren =
  AuthedBlogCategoriesRoute._addFileChildren(AuthedBlogCategoriesRouteChildren)

interface AuthedContentRouteChildren {
  AuthedContentIndexRoute: typeof AuthedContentIndexRoute
  AuthedContentLessonsIdRoute: typeof AuthedContentLessonsIdRoute
}

const AuthedContentRouteChildren: AuthedContentRouteChildren = {
  AuthedContentIndexRoute: AuthedContentIndexRoute,
  AuthedContentLessonsIdRoute: AuthedContentLessonsIdRoute,
}

const AuthedContentRouteWithChildren = AuthedContentRoute._addFileChildren(
  AuthedContentRouteChildren,
)

interface AuthedFamiliesRouteChildren {
  AuthedFamiliesIdRoute: typeof AuthedFamiliesIdRoute
  AuthedFamiliesIndexRoute: typeof AuthedFamiliesIndexRoute
}

const AuthedFamiliesRouteChildren: AuthedFamiliesRouteChildren = {
  AuthedFamiliesIdRoute: AuthedFamiliesIdRoute,
  AuthedFamiliesIndexRoute: AuthedFamiliesIndexRoute,
}

const AuthedFamiliesRouteWithChildren = AuthedFamiliesRoute._addFileChildren(
  AuthedFamiliesRouteChildren,
)

interface AuthedPagesRouteChildren {
  AuthedPagesIdRoute: typeof AuthedPagesIdRoute
  AuthedPagesIndexRoute: typeof AuthedPagesIndexRoute
  AuthedPagesIdBlocksBlockIdRoute: typeof AuthedPagesIdBlocksBlockIdRoute
}

const AuthedPagesRouteChildren: AuthedPagesRouteChildren = {
  AuthedPagesIdRoute: AuthedPagesIdRoute,
  AuthedPagesIndexRoute: AuthedPagesIndexRoute,
  AuthedPagesIdBlocksBlockIdRoute: AuthedPagesIdBlocksBlockIdRoute,
}

const AuthedPagesRouteWithChildren = AuthedPagesRoute._addFileChildren(
  AuthedPagesRouteChildren,
)

interface AuthedSchoolsRouteChildren {
  AuthedSchoolsIdRoute: typeof AuthedSchoolsIdRoute
  AuthedSchoolsIndexRoute: typeof AuthedSchoolsIndexRoute
}

const AuthedSchoolsRouteChildren: AuthedSchoolsRouteChildren = {
  AuthedSchoolsIdRoute: AuthedSchoolsIdRoute,
  AuthedSchoolsIndexRoute: AuthedSchoolsIndexRoute,
}

const AuthedSchoolsRouteWithChildren = AuthedSchoolsRoute._addFileChildren(
  AuthedSchoolsRouteChildren,
)

interface AuthedUsersRouteChildren {
  AuthedUsersIdRoute: typeof AuthedUsersIdRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
}

const AuthedUsersRouteChildren: AuthedUsersRouteChildren = {
  AuthedUsersIdRoute: AuthedUsersIdRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
}

const AuthedUsersRouteWithChildren = AuthedUsersRoute._addFileChildren(
  AuthedUsersRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAnnouncementsRoute: typeof AuthedAnnouncementsRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedBlogRoute: typeof AuthedBlogRouteWithChildren
  AuthedBlogCategoriesRoute: typeof AuthedBlogCategoriesRouteWithChildren
  AuthedContentRoute: typeof AuthedContentRouteWithChildren
  AuthedCouponsRoute: typeof AuthedCouponsRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedEmailRoute: typeof AuthedEmailRoute
  AuthedFamiliesRoute: typeof AuthedFamiliesRouteWithChildren
  AuthedFlagsRoute: typeof AuthedFlagsRoute
  AuthedLanguagesRoute: typeof AuthedLanguagesRoute
  AuthedMediaRoute: typeof AuthedMediaRoute
  AuthedPagesRoute: typeof AuthedPagesRouteWithChildren
  AuthedPaymentsRoute: typeof AuthedPaymentsRoute
  AuthedPlansRoute: typeof AuthedPlansRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSchoolsRoute: typeof AuthedSchoolsRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedSubscriptionsRoute: typeof AuthedSubscriptionsRoute
  AuthedTranslationsRoute: typeof AuthedTranslationsRoute
  AuthedTranslationsLegacyRoute: typeof AuthedTranslationsLegacyRoute
  AuthedUsersRoute: typeof AuthedUsersRouteWithChildren
  AuthedWebhooksRoute: typeof AuthedWebhooksRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAnnouncementsRoute: AuthedAnnouncementsRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedBlogRoute: AuthedBlogRouteWithChildren,
  AuthedBlogCategoriesRoute: AuthedBlogCategoriesRouteWithChildren,
  AuthedContentRoute: AuthedContentRouteWithChildren,
  AuthedCouponsRoute: AuthedCouponsRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedEmailRoute: AuthedEmailRoute,
  AuthedFamiliesRoute: AuthedFamiliesRouteWithChildren,
  AuthedFlagsRoute: AuthedFlagsRoute,
  AuthedLanguagesRoute: AuthedLanguagesRoute,
  AuthedMediaRoute: AuthedMediaRoute,
  AuthedPagesRoute: AuthedPagesRouteWithChildren,
  AuthedPaymentsRoute: AuthedPaymentsRoute,
  AuthedPlansRoute: AuthedPlansRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSchoolsRoute: AuthedSchoolsRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedSubscriptionsRoute: AuthedSubscriptionsRoute,
  AuthedTranslationsRoute: AuthedTranslationsRoute,
  AuthedTranslationsLegacyRoute: AuthedTranslationsLegacyRoute,
  AuthedUsersRoute: AuthedUsersRouteWithChildren,
  AuthedWebhooksRoute: AuthedWebhooksRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
